const FUNCTIONAL_CONSENT_GATED_KEYS = new Set([
  'policy-lang',
  'language-level',
  'newsletter-signup-dismissed',
  'christmas-lottery-dismissed',
]);

const isFunctionalConsentGranted = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return true;
    }

    const raw = window.localStorage.getItem('consent-preferences-v2');
    if (!raw) return true;

    const parsed = JSON.parse(raw);
    return parsed?.categories?.functional === true;
  } catch (_) {
    return true;
  }
};

export const safeLocalStorageGetItem = (key, fallbackValue = null) => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return fallbackValue;
    }

    const value = window.localStorage.getItem(key);
    return value === null ? fallbackValue : value;
  } catch (error) {
    console.warn(`[Storage] localStorage.getItem failed for "${key}"`, error);
    return fallbackValue;
  }
};

export const safeLocalStorageSetItem = (key, value) => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return false;
    }

    if (FUNCTIONAL_CONSENT_GATED_KEYS.has(key) && !isFunctionalConsentGranted()) {
      return false;
    }

    window.localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn(`[Storage] localStorage.setItem failed for "${key}"`, error);
    return false;
  }
};

export const safeLocalStorageRemoveItem = (key) => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return false;
    }

    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.warn(`[Storage] localStorage.removeItem failed for "${key}"`, error);
    return false;
  }
};

export const clearFunctionalConsentData = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return false;
    }

    FUNCTIONAL_CONSENT_GATED_KEYS.forEach((key) => {
      window.localStorage.removeItem(key);
    });
    return true;
  } catch (error) {
    console.warn('[Storage] Failed to clear functional consent data', error);
    return false;
  }
};
